import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect, useContext } from 'react';
import { Input, TextArea, Select, TextAreaAdvanced, InputImageUploadSimple } from "../../../../../Layout/Forms/Form";
import UserAccessManagerRequests from './UserAccessManagerRequests';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function UserAccessManagerModal({ show, handleModalShow, handleModalhide, id }) {
    // const [show, setShow] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            email: '',
            permissions: '',
            id_venues: id,
        },
        errors: []
    });


    const handleSubmitForm = async () => {
        let info = await UserAccessManagerRequests.postAddMemberVenue(state.form);
        if (info) {
            if (info.status) {
                handleModalhide();
                toast.success("Membro adicionado com sucesso", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            } else {
                setState({
                    ...state,
                    errors: info.errors
                })
                toast.error("Verifique os erros apresentados no formulário", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        }
    }

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    useEffect(() => {
        if (show) {
            handleChangeInputs({
                target: {
                    name: 'id_venues',
                    value: id
                }
            })
        }
    }, [show])




    return (
        <>
            <Modal
                show={show}
                onHide={handleModalhide}

            >
                <Modal.Header closeButton>
                    <Modal.Title>Adicionar membro</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-8">
                            <Input
                                label="Email"
                                name="email"
                                value={state.form.email}
                                onChange={(e) => handleChangeInputs(e)}
                                type="text"
                                errors={state.errors}
                            />
                        </div>
                        <div className="col-4">
                            <Select
                                label="Cargo"
                                name="permissions"
                                value={state.form.permissions}
                                onChangeOption={(e) => handleChangeInputs(e)}
                                options={[
                                    {
                                        label: "Proprietário",
                                        value: "owner"
                                    },
                                    {
                                        label: "Porteiro",
                                        value: "doorman"
                                    },

                                ]}
                                errors={state.errors}
                            />
                        </div>


                    </div>


                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalhide}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={handleSubmitForm}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <ToastContainer /> */}
        </>
    );
}

export default UserAccessManagerModal;